'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { cn } from '../../../shared/cn';
import { Button } from '../Button';
type DropdownButtonProps = {
  className?: string;
  as?: React.ElementType;
} & Omit<Headless.MenuButtonProps<typeof Button>, 'className' | 'as'>;
export function DropdownButton(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      as: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const as = t1 === undefined ? Button : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("data-active:ring-2 data-active:ring-algonavy-400! data-active:ring-outline", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== as || $[7] !== props || $[8] !== t2) {
    t3 = <Headless.MenuButton as={as} {...props} className={t2} />;
    $[6] = as;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}